import { render, staticRenderFns } from "./BaseWaitingRoom.vue?vue&type=template&id=b2bcfe80&scoped=true&lang=pug"
import script from "./BaseWaitingRoom.vue?vue&type=script&lang=ts"
export * from "./BaseWaitingRoom.vue?vue&type=script&lang=ts"
import style0 from "./BaseWaitingRoom.vue?vue&type=style&index=0&id=b2bcfe80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bcfe80",
  null
  
)

export default component.exports